import React from 'react';
import { CheckCircle, BookOpen, Brain, Heart, Shield, AlertCircle, Clock, FileText, Download, Users, X } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
import { TestimonialCard } from './ui/TestimonialCard';
import { BonusCard } from './ui/BonusCard';
import { useMetaPixel } from '../hooks/useMetaPixel';
import { CountdownTimer } from './CountdownTimer';
const CHECKOUT_URL = 'https://maestros.ebookditales.com/cart/44752368664712:1';
export function SalesPage() {
  useMetaPixel();
  const openCheckout = () => {
    window.open(CHECKOUT_URL, '_blank');
  };
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('comprar');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900 overflow-x-hidden pt-10" data-id="element-17">
      {/* Countdown Timer - Fixed Top Bar */}
      <CountdownTimer data-id="element-18" />

      {/* HERO SECTION - Optimized for mobile viewport */}
      <section className="min-h-screen flex flex-col justify-center py-4 md:py-20 px-3 md:px-4 bg-gradient-to-b from-white to-gray-50" data-id="element-19">
        <div className="max-w-4xl mx-auto text-center" data-id="element-20">
          <div className="inline-block bg-purple-100 text-purple-800 font-bold px-3 py-0.5 rounded-full text-xs md:text-sm mb-2 md:mb-6 uppercase tracking-wider" data-id="element-21">
            MEGA PACK AULA REAL™
          </div>

          <h1 className="text-2xl md:text-6xl font-black text-gray-900 leading-tight md:leading-relaxed mb-2 md:mb-4" data-id="element-22">
            Inclusión posible.
            <br data-id="element-23" />
            Aula sostenida.
            <br data-id="element-24" />
            <span className="text-purple-700 bg-purple-50 px-1 md:px-2" data-id="element-25">
              Docentes menos agotados.
            </span>
          </h1>

          {/* Subtitle - moved from top bar */}
          <p className="text-xs md:text-base text-gray-500 font-medium mb-3 md:mb-10 max-w-2xl mx-auto px-2" data-id="element-26">
            PARA DOCENTES DE NIVEL INICIAL Y PRIMARIO (4 A 12 AÑOS) QUE QUIEREN
            INCLUIR EN AULAS CON TDAH, DISLEXIA Y TEA
          </p>

          {/* Main Product Image */}
          <div onClick={openCheckout} className="cursor-pointer mx-auto mb-3 md:my-10 max-w-[280px] md:max-w-3xl group hover:scale-[1.02] transition-transform duration-300" data-id="element-27">
            <img src="https://cdn.magicpatterns.com/uploads/9SyEX6cgdDRLi2eWVbR6UA/eacf99d0-6f2f-4a41-a992-87b62462c312-removebg-preview.png" alt="MEGA PACK AULA REAL™ - Sistema completo para docentes" className="w-full h-auto drop-shadow-2xl" data-id="element-28" />
          </div>

          {/* Benefits box - Hidden on mobile, visible on desktop */}
          <div className="hidden md:block bg-white p-6 rounded-xl shadow-lg border border-gray-200 text-left max-w-3xl mx-auto mb-10" data-id="element-29">
            <p className="mb-4 font-medium" data-id="element-30">
              MEGA PACK AULA REAL™ es un sistema completo para docentes, creado
              para acompañarte a:
            </p>
            <ul className="space-y-3" data-id="element-31">
              {['Incluir alumnos con TDAH, Dislexia y TEA', 'Sostener el aula sin perder al grupo', 'Dejar de improvisar todos los días', 'Enseñar lo mismo, de otra manera', 'Terminar la jornada sin agotamiento mental ni corporal'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-32">
                  <CheckCircle className="w-6 h-6 text-green-500 shrink-0" data-id="element-33" />
                  <span data-id="element-34">{item}</span>
                </li>)}
            </ul>
          </div>

          <CTAButton onClick={scrollToPricing} subtext="Descarga inmediata - Acceso de por vida" data-id="element-35">
            SÍ, QUIERO EL MEGA PACK
          </CTAButton>
        </div>
      </section>

      {/* PROBLEM AGITATION */}
      <section className="py-16 px-4 bg-white" data-id="element-36">
        <div className="max-w-3xl mx-auto" data-id="element-37">
          <div className="border-l-4 border-purple-600 pl-6 py-2 mb-10" data-id="element-38">
            <h2 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-39">
              Si sos docente, esto te va a sonar demasiado familiar…
            </h2>
            <p className="text-lg text-gray-600" data-id="element-40">
              Entrás al aula con planificación. Pero en minutos, la realidad la
              desarma.
            </p>
          </div>

          <p className="text-lg mb-6" data-id="element-41">
            Un niño que no puede quedarse quieto. Otro que evita leer. Otro que
            estalla emocionalmente.
          </p>

          <p className="text-lg font-bold mb-4" data-id="element-42">Y vos tratando de:</p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-10" data-id="element-43">
            {['Enseñar', 'Contener', 'Adaptar', 'Cuidar el clima', 'No dejar a nadie afuera'].map((item, i) => <div key={i} className="bg-gray-50 p-3 rounded-lg text-center font-medium border border-gray-200" data-id="element-44">
                {item}
              </div>)}
            <div className="bg-purple-100 p-3 rounded-lg text-center font-bold text-purple-800 border border-purple-200" data-id="element-45">
              Todo al mismo tiempo
            </div>
          </div>
        </div>
      </section>

      {/* THE SILENT CYCLE */}
      <section className="py-16 px-4 bg-gray-900 text-white" data-id="element-46">
        <div className="max-w-4xl mx-auto text-center" data-id="element-47">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-red-500" data-id="element-48">
            El ciclo silencioso del agotamiento
          </h2>

          <div className="grid md:grid-cols-4 gap-6 text-center relative" data-id="element-49">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-gray-700 -z-10 transform -translate-y-1/2" data-id="element-50"></div>

            {[{
            icon: AlertCircle,
            text: 'Adaptar sobre la marcha'
          }, {
            icon: Brain,
            text: 'Decidir en caliente'
          }, {
            icon: Clock,
            text: 'Improvisar estrategias'
          }, {
            icon: Heart,
            text: 'Sostener emociones'
          }].map((item, i) => <div key={i} className="bg-gray-800 p-6 rounded-xl border border-gray-700 z-10" data-id="element-51">
                <item.icon className="w-10 h-10 text-purple-400 mx-auto mb-4" data-id="element-52" />
                <p className="font-medium" data-id="element-53">{item.text}</p>
              </div>)}
          </div>

          <p className="mt-12 text-xl italic text-gray-300" data-id="element-54">
            "Volver a casa pensando 'mañana pruebo otra cosa'. El cuerpo termina
            cansado. La cabeza no se apaga."
          </p>
        </div>
      </section>

      {/* THE REAL PROBLEM */}
      <section className="py-16 px-4 bg-white" data-id="element-55">
        <div className="max-w-3xl mx-auto text-center" data-id="element-56">
          <h2 className="text-3xl font-bold mb-8" data-id="element-57">
            El problema real (y no es lo que pensás)
          </h2>

          <div className="space-y-4 mb-10" data-id="element-58">
            <div className="flex items-center justify-center gap-2 text-lg text-red-600 font-medium" data-id="element-59">
              <X className="w-6 h-6" data-id="element-60" /> No es que no sepas enseñar
            </div>
            <div className="flex items-center justify-center gap-2 text-lg text-red-600 font-medium" data-id="element-61">
              <X className="w-6 h-6" data-id="element-62" /> No es que te falte paciencia
            </div>
            <div className="flex items-center justify-center gap-2 text-lg text-red-600 font-medium" data-id="element-63">
              <X className="w-6 h-6" data-id="element-64" /> No es que no tengas vocación
            </div>
          </div>

          <div className="bg-purple-50 border-2 border-purple-200 p-8 rounded-2xl" data-id="element-65">
            <p className="text-2xl font-bold text-gray-900 mb-4" data-id="element-66">
              👉 El problema es que el aula real exige herramientas que nadie te
              enseñó a manejar.
            </p>
            <p className="text-lg text-gray-700" data-id="element-67">
              La mayoría de los docentes no está quemada. Está saturada.
              Improvisar todos los días también desgasta.
            </p>
          </div>
        </div>
      </section>

      {/* SOLUTION */}
      <section className="py-20 px-4 bg-purple-900 text-white" data-id="element-68">
        <div className="max-w-5xl mx-auto" data-id="element-69">
          <div className="text-center mb-16" data-id="element-70">
            <span className="text-purple-300 font-bold tracking-widest uppercase mb-2 block" data-id="element-71">
              La solución pensada para el aula real
            </span>
            <h2 className="text-4xl md:text-6xl font-black mb-6" data-id="element-72">
              MEGA PACK AULA REAL™
            </h2>
            <p className="text-xl max-w-2xl mx-auto text-purple-100" data-id="element-73">
              No es un curso teórico. No es un manual frío. No es diagnóstico.
              Es un sistema de acompañamiento docente.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-74">
            <div className="bg-white/10 p-8 rounded-2xl backdrop-blur-sm border border-white/20" data-id="element-75">
              <h3 className="text-2xl font-bold mb-6" data-id="element-76">Diseñado para darte:</h3>
              <ul className="space-y-4" data-id="element-77">
                {['Criterio para entender lo que pasa', 'Herramientas claras para intervenir', 'Menos decisiones en caliente', 'Más sensación de control', 'Sostenibilidad real en el tiempo'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-78">
                    <CheckCircle className="w-6 h-6 text-green-400 shrink-0" data-id="element-79" />
                    <span className="text-lg" data-id="element-80">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div className="text-center" data-id="element-81">
              <div className="text-6xl font-black text-white/20 mb-4" data-id="element-82">
                1, 2, 3
              </div>
              <h3 className="text-3xl font-bold mb-4" data-id="element-83">
                Descargás. Leés. Aplicás.
              </h3>
              <p className="text-purple-200 mb-8" data-id="element-84">
                Sin convertirte en especialista. Sin duplicar trabajo.
              </p>
              <CTAButton onClick={scrollToPricing} className="bg-white text-purple-900 hover:bg-gray-100 border-gray-300" data-id="element-85">
                ACCEDER AHORA
              </CTAButton>
            </div>
          </div>
        </div>
      </section>

      {/* WHY IT WORKS */}
      <section className="py-16 px-4 bg-white" data-id="element-86">
        <div className="max-w-6xl mx-auto" data-id="element-87">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-88">
            ¿Por qué este material funciona?
          </h2>

          <div className="grid md:grid-cols-4 gap-8" data-id="element-89">
            {[{
            title: 'No patologiza',
            desc: 'Traduce conductas difíciles en claves pedagógicas concretas.',
            icon: Brain
          }, {
            title: 'No duplica trabajo',
            desc: 'Te muestra cómo adaptar sin rehacer toda la planificación.',
            icon: FileText
          }, {
            title: 'Incluye al docente',
            desc: 'Porque el cuerpo docente también se cansa.',
            icon: Users
          }, {
            title: 'No son ideas sueltas',
            desc: 'Son tomos estructurados + actividades listas.',
            icon: BookOpen
          }].map((item, i) => <div key={i} className="text-center p-6 rounded-xl hover:shadow-lg transition-shadow border border-gray-100" data-id="element-90">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4 text-purple-600" data-id="element-91">
                  <item.icon className="w-8 h-8" data-id="element-92" />
                </div>
                <h3 className="text-xl font-bold mb-2" data-id="element-93">{item.title}</h3>
                <p className="text-gray-600" data-id="element-94">{item.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* RESULTS */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-95">
        <div className="max-w-4xl mx-auto" data-id="element-96">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-97">
            Resultados que se notan
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-98">
            <div className="bg-white p-8 rounded-xl shadow-md border-t-4 border-green-500" data-id="element-99">
              <h3 className="text-xl font-bold mb-6 flex items-center gap-2" data-id="element-100">
                <Users className="w-6 h-6 text-green-500" data-id="element-101" /> En los alumnos:
              </h3>
              <ul className="space-y-3" data-id="element-102">
                {['Más participación', 'Menos frustración', 'Más posibilidades reales de aprender', 'Menos conflictos constantes'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-103">
                    <CheckCircle className="w-5 h-5 text-green-500" data-id="element-104" /> {item}
                  </li>)}
              </ul>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-md border-t-4 border-purple-500" data-id="element-105">
              <h3 className="text-xl font-bold mb-6 flex items-center gap-2" data-id="element-106">
                <Heart className="w-6 h-6 text-purple-500" data-id="element-107" /> En vos como
                docente:
              </h3>
              <ul className="space-y-3" data-id="element-108">
                {['Más claridad', 'Menos saturación', 'Menos culpa', 'Jornadas más sostenibles'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-700" data-id="element-109">
                    <CheckCircle className="w-5 h-5 text-purple-500" data-id="element-110" /> {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="text-center mt-10" data-id="element-111">
            <p className="text-xl font-medium text-gray-600 italic" data-id="element-112">
              "El agotamiento docente no viene de enseñar. Viene de sostener sin
              apoyo."
            </p>
          </div>
        </div>
      </section>

      {/* WHAT'S INCLUDED */}
      <section className="py-16 px-4 bg-white" data-id="element-113">
        <div className="max-w-5xl mx-auto" data-id="element-114">
          <h2 className="text-3xl md:text-5xl font-black text-center mb-4" data-id="element-115">
            ¿Qué incluye exactamente?
          </h2>
          <p className="text-xl text-center text-gray-600 mb-12" data-id="element-116">
            Todo en un solo lugar. Sin convertirte en especialista.
          </p>

          <div className="grid md:grid-cols-2 gap-12" data-id="element-117">
            <div data-id="element-118">
              <h3 className="text-2xl font-bold text-purple-700 mb-6 flex items-center gap-2" data-id="element-119">
                <BookOpen className="w-8 h-8" data-id="element-120" /> 6 TOMOS PROFESIONALES
              </h3>
              <ul className="space-y-4" data-id="element-121">
                {['No es falta de voluntad – entender la diversidad sin culpas', 'Bienvenida al aula real', 'Cuando el cuerpo no acompaña al aula', 'Leer y escribir sin sufrir (cuando el problema no es la inteligencia)', 'Adaptar sin rehacer todo – enseñar lo mismo de otra manera', 'El vínculo también enseña – emociones, frustraciones y bienestar docente'].map((item, i) => <li key={i} className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-122">
                    <span className="bg-purple-600 text-white w-6 h-6 rounded-full flex items-center justify-center text-sm font-bold shrink-0 mt-0.5" data-id="element-123">
                      {i + 1}
                    </span>
                    <span className="font-medium text-gray-800" data-id="element-124">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div data-id="element-125">
              <h3 className="text-2xl font-bold text-blue-700 mb-6 flex items-center gap-2" data-id="element-126">
                <Download className="w-8 h-8" data-id="element-127" /> MATERIALES LISTOS PARA USAR
              </h3>
              <div className="space-y-6" data-id="element-128">
                <div className="bg-blue-50 p-6 rounded-xl border border-blue-100" data-id="element-129">
                  <h4 className="font-bold text-blue-900 mb-3" data-id="element-130">DISLEXIA</h4>
                  <div className="flex gap-4" data-id="element-131">
                    <span className="bg-white px-3 py-1 rounded shadow-sm text-sm font-medium" data-id="element-132">
                      ▸ 24 actividades de Matemática
                    </span>
                    <span className="bg-white px-3 py-1 rounded shadow-sm text-sm font-medium" data-id="element-133">
                      ▸ 24 actividades de Lengua
                    </span>
                  </div>
                </div>

                <div className="bg-orange-50 p-6 rounded-xl border border-orange-100" data-id="element-134">
                  <h4 className="font-bold text-orange-900 mb-3" data-id="element-135">TDAH</h4>
                  <span className="bg-white px-3 py-1 rounded shadow-sm text-sm font-medium" data-id="element-136">
                    ▸ 120 fichas de actividades prácticas
                  </span>
                </div>

                <div className="bg-green-50 p-6 rounded-xl border border-green-100" data-id="element-137">
                  <h4 className="font-bold text-green-900 mb-3" data-id="element-138">TEA</h4>
                  <div className="flex flex-wrap gap-2" data-id="element-139">
                    <span className="bg-white px-3 py-1 rounded shadow-sm text-sm font-medium" data-id="element-140">
                      ▸ Pensamientos (9)
                    </span>
                    <span className="bg-white px-3 py-1 rounded shadow-sm text-sm font-medium" data-id="element-141">
                      ▸ Emociones (16)
                    </span>
                    <span className="bg-white px-3 py-1 rounded shadow-sm text-sm font-medium" data-id="element-142">
                      ▸ Conducta (6)
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-143">
            <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm md:text-base font-medium text-gray-600 mb-8" data-id="element-144">
              <span className="flex items-center gap-2" data-id="element-145">
                <Download className="w-5 h-5 text-green-500" data-id="element-146" /> Descarga
                inmediata
              </span>
              <span className="flex items-center gap-2" data-id="element-147">
                <Clock className="w-5 h-5 text-green-500" data-id="element-148" /> Acceso de por vida
              </span>
              <span className="flex items-center gap-2" data-id="element-149">
                <Shield className="w-5 h-5 text-green-500" data-id="element-150" /> Garantía 7 días
              </span>
            </div>
            <CTAButton onClick={scrollToPricing} data-id="element-151">
              QUIERO ACCEDER AHORA
            </CTAButton>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-152">
        <div className="max-w-6xl mx-auto" data-id="element-153">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-12" data-id="element-154">
            Lo que dicen otras docentes
          </h2>

          <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-155">
            <TestimonialCard name="Claudia" role="Docente Nivel Primario" location="Córdoba" imageInitials="C" quote="Por fin dejé de improvisar. Mis alumnos con TDAH están más conectados y yo llego a casa con energía." data-id="element-156" />
            <TestimonialCard name="Mariana" role="Maestra de Apoyo" location="Buenos Aires" imageInitials="M" quote="El material de dislexia es oro. Ahorré horas de planificación y los chicos avanzan de verdad." data-id="element-157" />
            <TestimonialCard name="Silvia" role="Directora" location="Rosario" imageInitials="S" quote="Sentía mucha culpa por no saber cómo ayudar. Este pack me dio paz mental y herramientas reales." data-id="element-158" />
          </div>
          <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-159">
            <TestimonialCard name="Gabriela" role="Docente 3er Grado" location="Mendoza" imageInitials="G" quote="Las fichas están listas para usar. Literalmente imprimo y doy la clase. Un alivio total." data-id="element-160" />
            <TestimonialCard name="Patricia" role="Docente Nivel Inicial" location="La Plata" imageInitials="P" quote="Lo mejor es que no me siento sola. Entendí que no es falta de vocación, es falta de herramientas." data-id="element-161" />
          </div>
        </div>
      </section>

      {/* BONUSES */}
      <section className="py-16 px-4 bg-gradient-to-b from-purple-50 to-white" data-id="element-162">
        <div className="max-w-6xl mx-auto" data-id="element-163">
          <div className="text-center mb-12" data-id="element-164">
            <span className="bg-red-600 text-white px-4 py-1 rounded-full text-sm font-bold uppercase tracking-wider animate-bounce inline-block mb-4" data-id="element-165">
              🎁 GRATIS POR HOY
            </span>
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-166">
              3 Bonos Exclusivos de Regalo
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-167">
              Además del Mega Pack, hoy te llevás estos 3 recursos adicionales
              sin costo extra
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-168">
            <BonusCard bonoNumber={1} title="¿Qué hago cuando…?" imageUrl="https://cdn.magicpatterns.com/uploads/m6cg2YDCebSgsSjkukdGA1/58eb3265-36e3-480a-bc41-e35bd9011443-removebg-preview.png" benefits={['Guía rápida para situaciones reales del aula', 'Decisiones claras sin improvisar', 'Menos desgaste en el momento crítico']} data-id="element-169" />
            <BonusCard bonoNumber={2} title="Conductas que cansan, traducidas al lenguaje pedagógico" imageUrl="https://cdn.magicpatterns.com/uploads/w687Pf1gjg73XKvxtbhTPF/3ef999dd-dc1a-4160-bdd0-294fa728349a-removebg-preview.png" benefits={['Entendé lo que el aula muestra', 'Claves pedagógicas sin patologizar', 'Más criterio, menos culpa']} data-id="element-170" />
            <BonusCard bonoNumber={3} title="El aula también se cierra" imageUrl="https://cdn.magicpatterns.com/uploads/qT9szAwSzA768s1qqJyo6k/dc89425d-36a9-4945-a3b2-2ff83164c424-removebg-preview.png" benefits={['Cómo cerrar el día sin llevarte todo', 'Menos carga mental y emocional', 'Más sostenibilidad docente']} data-id="element-171" />
          </div>
        </div>
      </section>

      {/* PRICING SECTION */}
      <section id="comprar" className="py-20 px-4 bg-gradient-to-b from-purple-900 to-purple-800 text-white" data-id="element-172">
        <div className="max-w-4xl mx-auto" data-id="element-173">
          <div className="bg-white text-gray-900 rounded-3xl shadow-2xl overflow-hidden border-4 border-yellow-400" data-id="element-174">
            <div className="bg-yellow-400 py-4 text-center" data-id="element-175">
              <h3 className="text-xl font-black uppercase tracking-widest text-yellow-900" data-id="element-176">
                Oferta Especial de Lanzamiento
              </h3>
            </div>

            <div className="p-8 md:p-12 text-center" data-id="element-177">
              <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-178">
                Sistema Completo MEGA PACK AULA REAL™
              </h2>
              <p className="text-gray-500 mb-8" data-id="element-179">
                Acceso inmediato y de por vida a todo el material
              </p>

              <div className="flex items-center justify-center gap-4 mb-8" data-id="element-180">
                <span className="text-2xl text-gray-400 line-through" data-id="element-181">
                  $45.000
                </span>
                <span className="text-6xl md:text-7xl font-black text-green-600" data-id="element-182">
                  $19.990
                </span>
                <span className="text-xl font-bold text-gray-500" data-id="element-183">ARS</span>
              </div>

              <div className="bg-gray-50 p-6 rounded-xl mb-8 text-left max-w-lg mx-auto border border-gray-200" data-id="element-184">
                <p className="font-bold text-gray-900 mb-4 border-b pb-2" data-id="element-185">
                  🎁 TODO LO QUE RECIBÍS HOY:
                </p>
                <ul className="space-y-3" data-id="element-186">
                  <li className="flex items-center gap-2" data-id="element-187">
                    <CheckCircle className="w-5 h-5 text-green-500" data-id="element-188" /> Los 6
                    tomos completos AULA REAL™
                  </li>
                  <li className="flex items-center gap-2" data-id="element-189">
                    <CheckCircle className="w-5 h-5 text-green-500" data-id="element-190" /> 48
                    actividades para Dislexia
                  </li>
                  <li className="flex items-center gap-2" data-id="element-191">
                    <CheckCircle className="w-5 h-5 text-green-500" data-id="element-192" /> 120
                    fichas prácticas para TDAH
                  </li>
                  <li className="flex items-center gap-2" data-id="element-193">
                    <CheckCircle className="w-5 h-5 text-green-500" data-id="element-194" /> 31
                    actividades para TEA
                  </li>
                  <li className="flex items-center gap-2" data-id="element-195">
                    <CheckCircle className="w-5 h-5 text-green-500" data-id="element-196" />{' '}
                    <strong data-id="element-197">BONOS DE REGALO</strong>
                  </li>
                </ul>
              </div>

              <CTAButton className="w-full md:w-auto text-xl py-6 px-12 animate-pulse" data-id="element-198">
                ACCEDER AL MEGA PACK AULA REAL™
              </CTAButton>

              <p className="mt-6 text-sm text-gray-500 flex items-center justify-center gap-4" data-id="element-199">
                <span className="flex items-center gap-1" data-id="element-200">
                  <Shield className="w-4 h-4" data-id="element-201" /> Pago Seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-202">
                  <Download className="w-4 h-4" data-id="element-203" /> Entrega Digital
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-16 px-4 bg-white" data-id="element-204">
        <div className="max-w-3xl mx-auto text-center" data-id="element-205">
          <div className="w-24 h-24 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-206">
            <Shield className="w-12 h-12 text-yellow-600" data-id="element-207" />
          </div>
          <h2 className="text-3xl font-bold mb-4" data-id="element-208">GARANTÍA TOTAL 7 DÍAS</h2>
          <p className="text-lg text-gray-600 mb-6" data-id="element-209">
            Probá el material durante una semana. Si no sentís más claridad,
            alivio y orden en tu práctica, te devolvemos el 100% del dinero.
          </p>
          <p className="font-bold text-gray-900" data-id="element-210">
            Sin preguntas. El riesgo es nuestro.
          </p>
        </div>
      </section>

      {/* FINAL CLOSING */}
      <section className="py-20 px-4 bg-gray-900 text-white text-center" data-id="element-211">
        <div className="max-w-3xl mx-auto" data-id="element-212">
          <h2 className="text-3xl font-bold mb-6" data-id="element-213">Para cerrar</h2>
          <p className="text-xl mb-8 text-gray-300" data-id="element-214">
            No estás cansado de enseñar. Estás cansado de improvisar todo el
            tiempo.
          </p>
          <div className="bg-purple-900/50 p-8 rounded-2xl border border-purple-500/30 mb-10" data-id="element-215">
            <p className="text-2xl font-bold text-white mb-2" data-id="element-216">
              MEGA PACK AULA REAL™
            </p>
            <p className="text-purple-200" data-id="element-217">No te exige más. Te sostiene.</p>
          </div>
          <CTAButton onClick={scrollToPricing} data-id="element-218">
            ACCEDER AHORA AL MEGA PACK
          </CTAButton>
          <p className="mt-8 text-sm text-gray-500" data-id="element-219">
            📩 Este es un producto digital. El acceso se envía automáticamente
            por correo electrónico luego de la compra.
          </p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-black text-gray-600 py-8 text-center text-sm border-t border-gray-800" data-id="element-220">
        <p data-id="element-221">
          © {new Date().getFullYear()} MEGA PACK AULA REAL™. Todos los
          derechos reservados.
        </p>
      </footer>
    </div>;
}